import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Formik, Form } from "formik";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import { useNavigate } from "react-router-dom";
import { excelFileDownload } from "../../componants/Excel Export/ExcelFileDownload";
import { Button, Card, Row, Col } from "react-bootstrap";
import toastNotify from "../../utils/ToastNotify";
import TextField from "../../componants/textField/TextField";
import SelectField from "../../componants/textField/SelectField";
import { useDispatch, useSelector } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import { BiFile, BiHomeAlt, BiPlus } from "react-icons/bi";
import TicketListCom from "./TicketListCom";

// This is worked with Export Excel data
const columns = [
  {
    field: "TICKET_ID",
    headerNm: "Ticket Id",
    textAlign: "left",
  },
  {
    field: "PRODUCT_NM",
    headerNm: "Product Name",
    textAlign: "left",
  },
  {
    field: "SUBJECT",
    headerNm: "Subject",
    textAlign: "left",
  },
  {
    field: "CREATE_DT",
    headerNm: "Create Date",
    textAlign: "center",
  },
  {
    field: "LAST_ACTIVITY_DT",
    headerNm: "Last Activity",
    textAlign: "center",
  },
  {
    field: "LAST_ACTIVITY_BY_NM",
    headerNm: "Last Replier Name",
    textAlign: "left",
  },
  {
    field: "STATUS_CD",
    headerNm: "Status",
    textAlign: "center",
  },
];

const Support = () => {
  const [ticket, setTicket] = useState([]);
  const navigate = useNavigate();
  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);
  const dispatch = useDispatch();

  async function fetchTicket(val) {
    try {
      dispatch(handleLoader(true));
      const data = {
        TICKET_ID: val?.ticketId || "",
        STATUS_CD: val?.statusValue || "",
        STATUS_TYPE: val?.statusValue || "",
        TICKET_TYPE: "C"
      };
      const result = await makeRequest("POST", urls.getTicket, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setTicket(response);
      } else {
        setTicket([]);
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function fetchTicketDtl(val) {
    try {
      dispatch(handleLoader(true));
      const data = {
        TICKET_ID: val.TICKET_ID
      };
      const result = await makeRequest("POST", urls.getTicketDtl, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0];
        navigate("/support/ticket-view", { state: { response: response } });

      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const updateReadStatus = async (row) => {
    try {
      dispatch(handleLoader(false));

      const data = {
        TICKET_ID: row.TICKET_ID,
      };

      const result = await makeRequest("POST", urls.updateReadStatus, data, {});
      if (result.STATUS === "0") {
        // Ignore Case
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(handleLoader(false));
    }
  };

  // This is run on ticket row click
  const handleClickOnTicketRow = async (row) => {
    await fetchTicketDtl(row);
    if (row.READ_STATUS !== "Y") {
      await updateReadStatus(row);
    }
  }

  useEffect(() => {
    fetchTicket()
  }, []);

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className=" date-time container-top mb-3">
          <div className="d-flex align-items-center">
            <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1"> Support</span>
            </div>
            <div className="d-flex align-items-center gap-2 ms-auto">
              <Button
                type="button"
                variant="success"
                className="btn-sm"
                onClick={() =>
                  excelFileDownload(columns, ticket, "Ticket-Report")
                }
              >
                <BiFile className="me-2" />
                Export Excel
              </Button>
              <Button
                type="button"
                varient="primary"
                className="btn-sm"
                onClick={() => {
                  navigate("/create-ticket")
                }}
              >
                <BiPlus className="me-2" />
                Create Ticket
              </Button>
            </div>
          </div>
        </div>

        <Card>
          <Card.Body>
            <Formik
              initialValues={{
                ticketId: "",
                statusValue: "",
                statusLabel: "ALL",
              }}
              onSubmit={(values) => fetchTicket(values)}
            >
              {({ setFieldValue, values, handleBlur }) => (
                <Form>
                  <Row>
                    <Col md={3}>
                      <TextField
                        label="Ticket ID"
                        name="ticketId"
                        id="ticketId"
                        maxLength={15}
                        value={values.ticketId}
                        onChange={(e) => {
                          const { value } = e.target;
                          setFieldValue("ticketId", value.toUpperCase());
                        }}
                        onBlur={handleBlur}
                      />
                    </Col>

                    <Col md={3} className="mt-md-0 mt-3">
                      <SelectField
                        name="status"
                        options={[
                          { value: "", label: 'All' },
                          { value: "ALL", label: 'All (Not include close)' },
                          { value: "O", label: 'Open' },
                          { value: "R", label: 'ReOpen' },
                          { value: "P", label: 'Pending' },
                          { value: "I", label: 'InProgress' },
                          { value: "C", label: 'Close' },
                        ]}
                        value={{ value: values.statusValue, label: values.statusLabel }}
                        placeholder='Status'
                        onChange={(e) => {
                          setFieldValue("statusValue", e?.value);
                          setFieldValue("statusLabel", e?.label);
                        }}
                      />
                    </Col>

                    <Col md={3} className="mt-md-0 mt-3">
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-sm">
                        Search
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>

        <TicketListCom ticket={ticket} handleClickOnTicketRow={handleClickOnTicketRow} screenWidth={screenWidth} flag="S" />
      </div>
    </>
  );
};

export default Support;
